import "core-js/modules/es.array.push.js";
import Bus from '@/assets/js/bus.js';
import { mapState } from 'vuex';
import { handleLocalStorage, routerJump, userBgColor } from '@/assets/js/utils.js';
import AgoraRTCClient from '@/assets/js/rtc-client-ng';
import Cookie from 'js-cookie';
import AWS from 'aws-sdk';
import QRCode from 'qrcode';
import i18n from '@/lang/index.js';
const nodeurl = require('url');
export default {
  data() {
    var _JSON$parse;
    return {
      userBgColor: userBgColor,
      partyPageInfo: {
        pageNum: 1,
        pageSize: 20,
        hasNextPage: false
      },
      scroll: {
        distance: 20,
        onScroll: this.openPartylist
      },
      partyListLoading: false,
      onlinePartyList: [],
      globalFunList: ['waffle', 'account', 'helpCenter'],
      multiAccountList: [],
      showRightPop: false,
      showErrorPassCode: false,
      serviceNameList: [],
      fullRotate: false,
      options: [{
        value: '1',
        label: 'accept'
      }, {
        value: '2',
        label: 'decline'
      }],
      val: '',
      freeTalk: false,
      showCopyButton: true,
      showUnread: false,
      flag: false,
      partyCode: '',
      showLeave: false,
      showReplace: false,
      dialogTableVisible: false,
      uploadLogoVisible: false,
      socket: null,
      isShare: false,
      endInfo: {
        title: 'endParty.title',
        content: '',
        cancel: 'endParty.cancel',
        save: 'endParty.save',
        show: false
      },
      publicInfo: {
        title: 'remainWords.switchPublicSetting',
        show: false,
        save: 'remainWords.goOn',
        content: '',
        cancel: 'endParty.cancel'
      },
      showInviteInfo: {
        show: false,
        title: 'invite.getLink',
        save: 'invite.saveInvite',
        hideCancel: true,
        hideSave: true
      },
      collaborateScroll: {
        distance: 10,
        onScroll: this.getCollaborateHadInvite
        // directive: '.inviteBox .hadInviteList'
      },

      collaboratePageInfo: {
        pageNum: 1,
        pageSize: 5,
        hasNextPage: false
      },
      receiverCollaborateScroll: {
        distance: 10,
        onScroll: this.getInvitedByOhter,
        directive: '.invitedMe .el-table__body-wrapper'
      },
      receiverCollaboratePageInfo: {
        pageNum: 1,
        pageSize: 5,
        hasNextPage: false
      },
      collaborateInfo: {
        show: false,
        title: '',
        save: 'invite.saveInvite',
        hideCancel: true,
        hideBottom: true
      },
      showShareFail: {
        show: false,
        title: 'common.shareFailed',
        save: 'common.gotIt',
        hideCancel: true
      },
      selectModule: 0,
      searchName: '',
      collaborateSearchName: '',
      isHost: false,
      raiseHandList: [],
      publicDailogVisiable: false,
      selectPublicChatInfo: null,
      inputTimer: null,
      showErrorEmailText: false,
      isCoordinator: false,
      agoraClient: null,
      fontVersion: '',
      backendVersion: '',
      ProducerFrontendVersion: '',
      ProducerBackendVersion: '',
      ProducerTagName: '',
      applicationName: handleLocalStorage('get', 'applicationName'),
      showUrlText: true,
      willInviteList: [],
      hadInviteList: [],
      willInviteCollaborate: [],
      hadInviteCollaborate: [],
      urlTextInfo: '',
      raiseHandStream: {},
      joinUserInfo: {},
      raisePrivateName: '',
      raisePrivateTagName: '',
      inputUrlText: '',
      privateLoading: false,
      replaceIndex: 1,
      sendEmail: true,
      leavePartyInfo: {},
      env: handleLocalStorage('get', 'partylineConfig') ? (_JSON$parse = JSON.parse(handleLocalStorage('get', 'partylineConfig'))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.apiEnv : '',
      tagName: {},
      logos: '',
      uploadFile: null,
      uploadParams: {},
      uploadDialogImg: require('@/assets/img/kioskPicture.png'),
      uploadObj: null,
      uploadLogoList: [],
      getUploadParams: {
        pageIndex: 1,
        pageSize: 20,
        nameLike: '',
        isDirectory: false,
        region: handleLocalStorage('get', 'region'),
        service: 'pp',
        type: 1,
        directoryName: '/Partyline/kiosk/companyLogo'
      },
      uploadLogoLoading: false,
      uploadLogoId: '',
      netWork: {
        upLinkNetWork: 'Good',
        downLinkNetWork: 'Good'
      },
      showRaiseHand: false,
      useIconFontLogoInKiosk: true,
      showSetting: false,
      showPartiAudioMatrix: false,
      settingPopupInfo: {
        show: false
      },
      showLoginButton: true,
      editPass: false,
      passCodeVal: '',
      showTips: true,
      audiOnlyOperation: [{
        label: 'AutoAudioOnly',
        value: 0
      }, {
        label: 'AllTimeAudioOnly',
        value: 1
      }, {
        label: 'Disabled',
        value: 2
      }],
      audioType: 2,
      checkMainWindow: true,
      checkShareScreen: true,
      hadInvite: [],
      Parser: require('@/assets/js/us.js'),
      selectType: 'invitedOther',
      invitedMeList: [],
      showConferenceRaise: false,
      showAudience: false,
      haveUnRead: false,
      role: false,
      participantAudioMatrix: false,
      showRaiseHandTips: false,
      qCode: '',
      qrCodeUrl: '',
      receivedCohost: {
        show: false,
        title: 'commonPartyHost.leftPane.partyOperation.ReceiverCoHost',
        hideSave: true,
        hideBottom: true
      },
      cohostScroll: {
        distance: 10,
        onScroll: this.getCoHostHadInvite
        // directive: '.inviteBox .hadInviteList'
      },

      cohostPageInfo: {
        pageNum: 1,
        pageSize: 5,
        hasNextPage: false
      },
      receiverCohostScroll: {
        distance: 10,
        onScroll: this.getInvitedByOther,
        directive: '.invitedMe .el-table__body-wrapper'
      },
      receiverCohostPageInfo: {
        pageNum: 1,
        pageSize: 10,
        hasNextPage: false
      },
      logoSvg: '',
      selectPosition: ''
    };
  },
  async created() {
    this.isHost ? this.role = true : this.role = false;
    this.State.isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    // 获取Producer版本号
    const that = this;
    // this.serviceNameList = this.$store.state.config.serviceNames

    if (this.role) {
      this.$backAndFrontVersion({
        ...this.$TVU,
        params: {
          serviceNameList: ['Producer']
        },
        success: function (val) {
          that.ProducerFrontendVersion = val[0].frontendVersion;
          that.ProducerBackendVersion = val[0].backendVersion;
          that.ProducerTagName = val[0].tagName;
        },
        error: function (val) {}
      });
    }
    const parserObj = this.Parser && new this.Parser();
    this.State.isMac = parserObj && parserObj.getOS().name === 'Mac OS';
    this.useIconFontLogoInKiosk = true;
    // 获取前端版本号
    let fontEndVersionStr = handleLocalStorage('get', 'partylineVersion');
    if (fontEndVersionStr && fontEndVersionStr.includes('_')) {
      fontEndVersionStr = fontEndVersionStr.substring(0, fontEndVersionStr.indexOf('_'));
    }
    this.fontVersion = fontEndVersionStr;
    // 获取后台版本号
    this.getBackendVersion();
    // 切换会议后关闭conference模式的Audience和RaiseHand
    Bus.$on('changeAudience', v => {
      this.showAudience = v;
    });
    Bus.$on('changeRaiseHand', v => {
      this.showConferenceRaise = v;
    });
    Bus.$off('executeHideConferenceOperate');
    Bus.$on('executeHideConferenceOperate', v => {
      this.hideConferenceOperate('chat');
    });
    Bus.$on('updateInitStatus', obj => {
      const {
        hasCopy,
        freeTalk,
        loginButton
      } = obj;
      Object.keys(obj).forEach(item => {
        // 初始化控制复制按钮
        if (item == 'hasCopy') {
          this.showCopyButton = hasCopy;
        }
        if (item == 'freeTalk') {
          this.freeTalk = freeTalk;
        }
        // 初始化控制登录按钮
        if (item === 'loginButton') {
          this.showLoginButton = loginButton;
        }
      });
    });
    Bus.$on('setLoginScreenButton', val => {
      const {
        buttonType,
        operationType
      } = val.buttonStatus;
      if (buttonType === 0) {
        operationType === 0 ? this.showLoginButton = false : this.showLoginButton = true;
      } else if (buttonType === 1) {
        // 控制与会者页面的复制连接按钮
        operationType === 0 ? this.showCopyButton = false : this.showCopyButton = true;
      } else if (buttonType === 9) {
        this.State.partyJoinInfo.status.audioMatrix = operationType;
      } else if (buttonType === 10) {
        if (operationType === 0) {
          this.State.partiAudioMatrixEnable = false;
          Bus.$emit('setAudioMatrix', false);
        } else {
          // host 页面不展示
          this.State.partiAudioMatrixEnable = true;
        }
      } else if (buttonType === 11) {
        if (!operationType) {
          routerJump('remove', {
            type: 'disableParty'
          });
        }
      }
    });
    Bus.$on('endParty', v => {
      this.replaceIndex = 1;
      this.selectPosition = '';
    });
    Bus.$on('changePartyAddress', val => {
      if (!val) return;
      console.log('changePartyAddress', val);
      this.raisePrivateName = '';
      this.raiseHandStream = {};
      // 这段代码是为了兼容commentator项目用的
      if (val.commentatorPartyCode) {
        this.partyCode = val.commentatorPartyCode;
        this.State.partyCode = val.currentId;
      } else {
        this.partyCode = val.currentId;
      }
      this.isCoordinator = (this.partyCode + '').length === 9;
      if (this.currentPartyInfo.title || val.title) {
        this.urlTextInfo = this.currentPartyInfo.title || val.title;
      } else if (val.startPartyTime || val.createTime) {
        this.urlTextInfo = new Date(val.startPartyTime || val.createTime).toLocaleDateString() + '   ' + new Date(val.startPartyTime || val.createTime).toLocaleTimeString();
        console.log('urlTextInfo', this.urlTextInfo);
      } else {
        this.urlTextInfo = this.$options.filters.returnStrByInfo(val.currentId, this.isCoordinator ? 3 : 4);
        console.log('urlTextInfo', this.urlTextInfo);
      }
      if (this.socket && this.socket.client) {
        this.socket.close(); // 手动停止websocket
        this.socket = null;
      }
      if (!this.$route.name.includes('group')) return;
      this.initRaiseHandList('init');
    });
    Bus.$on('setPartyTitle', v => {
      if (v.partyCode == this.currentPartyInfo.code || v.partyCode == this.$route.query.id) {
        this.urlTextInfo = v.title;
      }
    });
    Bus.$on('changeTitle', v => {
      this.urlTextInfo = v;
    });
    Bus.$on('showDialog', val => {
      this.dialogTableVisible = val.show;
      this.leavePartyInfo = val;
    });
    // 添加删除举手列表
    Bus.$on('raiseHand', v => {
      const {
        nickName,
        groupId,
        rtilCode
      } = v;
      if (groupId != this.partyCode || this.$route.name != 'group' && this.$route.name != 'channelParticipate') return;
      const obj = {
        ...{
          info: v
        },
        nickName,
        rtilCode: rtilCode,
        talkStatus: 'talk',
        loading: false
      };
      this.raiseHandList.push(obj);
    });
    Bus.$on('denyRaiseHand', v => {
      this.raiseHandList && this.raiseHandList.forEach((item, index) => {
        const rtilCode = item.rtilCode;
        if (rtilCode === v.rtilCode) {
          this.raiseHandList.splice(index, 1);
        }
      });
    });
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          const {
            mark,
            value
          } = val;
          this.raiseHandList && this.raiseHandList.forEach(inVal => {
            if (mark == inVal.rtilCode) {
              inVal.nickName = value;
              if (inVal.talkStatus == 'hangUp') {
                this.raisePrivateName = value;
              }
            }
          });
          if (this.State.galleryBroadcastInfo && this.State.galleryBroadcastInfo.rtilCode == mark) {
            this.State.galleryBroadcastInfo.nickName = value;
          }
        }
        if (val.key == 'tagName') {
          this.$set(this.tagName, val.mark, val.value);
        }
      });
    });
    Bus.$on('endParty', v => {
      this.raiseHandStream = {};
      this.State.galleryBroadcastInfo = null;
      this.State.gallerySpeakerInfo = null;
    });
    Bus.$on('saveUserInfo', v => {
      this.joinUserInfo = v;
    });
    Bus.$on('startPrivateConversation', v => {
      const {
        name,
        rtilCode,
        realPartyCode,
        byRaiseHand,
        crewRtilCode
      } = v;
      // 先判断举手列表里面是否有当前在私聊的rtilCode
      if (byRaiseHand) {
        if (v.crewRtilCode == this.State.currentRtilCode || v.rtilCode == this.State.currentRtilCode) {
          // 如果是自己的私聊
          this.State.privateInfo = v;
        } else {
          if (!this.State.privateInfoByOthers.length) {
            this.State.privateInfoByOthers.push(v);
          } else {
            this.State.privateInfoByOthers.forEach(val => {
              if (v.crewRtilCode != val.crewRtilCode || v.rtilCode != val.rtilCode) {
                this.State.privateInfoByOthers.push(v);
              }
            });
          }
        }
        if (crewRtilCode != this.State.currentRtilCode) return; // 只有是自己发起的私聊，才需要join。别的host发起的私聊直接return
        const _this = this;
        this.raiseHandList && this.raiseHandList.forEach(item => {
          if (item.rtilCode == rtilCode) {
            // 在判断当前的channels里面是否有这个视频
            if (!_this.State.galleryChannels[rtilCode]) {
              // 判断当前举手想要talk的人是否在当前party中
              if (!this.State.galleryPartyCodeList.includes(realPartyCode)) {
                this.joinPartyLine(realPartyCode, rtilCode);
                Bus.$emit('muteExternalParty');
              }
            }
            item.talkStatus = 'hangUp';
            this.raisePrivateName = name;
            this.raisePrivateTagName = item.tagName;
          }
        });
      }
    });
    Bus.$on('dealInitPrivateVideo', (result, rtcClient) => {
      const havePrivate = result.status.privateConversation;
      if (havePrivate) {
        const rtilCode = JSON.parse(havePrivate).rtilCode;
        this.getRealPartyCode(rtilCode, rtcClient);
      }
    });
    Bus.$on('cancelPrivateConversation', v => {
      const {
        rtilCode,
        realPartyCode,
        hadCancelRaiseHand
      } = v;
      if (v.crewRtilCode == this.State.currentRtilCode) {
        this.raisePrivateName = '';
        this.raiseHandStream = {};
      }
      this.raiseHandList && this.raiseHandList.forEach(item => {
        if (item.rtilCode == rtilCode) {
          if (!hadCancelRaiseHand) {
            this.refuseConversation(item, 'notShow');
          }
          if (v.crewRtilCode == this.State.currentRtilCode) {
            if (!this.State.galleryPartyCodeList.includes(realPartyCode)) {
              // 不在当前页的举手talk的人，host则离开私聊的party
              if (this.rtc) this.rtc.leave();
              this.rtc = null;
            }
            // host额外的party内去发流
            Bus.$emit('unmuteExternalParty');
          }
        }
      });
    });
    const _this = this;
    Bus.$on('setCompanyLogo', info => {
      if (!_this.isHost) {
        _this.useIconFontLogoInKiosk = false;
        _this.logos = info.url;
      }
    });
    Bus.$on('cancelCompanyLogo', () => {
      if (!_this.isHost) {
        _this.useIconFontLogoInKiosk = true;
      }
    });
    Bus.$on('notify', v => {
      const {
        key,
        layout
      } = v;
      if (key === 'updataLayout') {
        const layouts = layout.split('-')[0];
        const columns = layout.split('-')[1];
        this.State.groupLayout.layout = layouts;
        this.State.groupLayout.column = columns;
        this.State.groupLayout.layoutName = layout;
      }
    });
    Bus.$on('changeAudioTypeVal', () => {
      this.audioType = this.State.audioType;
      this.checkMainWindow = this.State.checkMainWindow;
      this.checkShareScreen = this.State.checkShareScreen;
    });
    Bus.$on('getCollaborateInfo', () => {
      this.getCollaborateHadInvite('init');
    });
    Bus.$on('crateShareFailed', () => {
      this.showShareFail.show = true;
    });
    // 用于 host 实时更新对方在邮件中点击的接受或者拒绝的操作
    Bus.$on('collaborateInvite', result => {
      if (!this.isHost) return;
      const {
        collaborateUserId,
        status,
        toEmail
      } = result;
      if (collaborateUserId != this.State.loginInfo.id) {
        this.hadInviteCollaborate.forEach(item => {
          if (item.collaborateUserId == collaborateUserId) {
            item.color = this.returnColor({
              status,
              collaborateEmail: toEmail
            });
            item.status = status;
          }
        });
      }
    });
    Bus.$on('deleteCollaborateInvite', result => {
      if (!result.PartyCode) {
        const {
          id,
          actionUserId,
          invite,
          actionUserEmail
        } = result;
        if (actionUserId == this.State.loginInfo.id) return;
        if (invite) {
          this.$message.warning(actionUserEmail + this.$t('personalInfo.removeInvitedMe'));
        } else {
          this.$message.warning(actionUserEmail + this.$t('personalInfo.refuseInvite'));
        }
        this.hadInviteCollaborate.forEach((item, index) => {
          if (item.id == id) {
            this.hadInviteCollaborate.splice(index, 1);
          }
        });
        this.invitedMeList.forEach((item1, index) => {
          if (item1.id == id) {
            this.invitedMeList.splice(index, 1);
          }
        });
      }
    });
    Bus.$on('raiseHand', val => {
      this.haveUnRead = true;
    });
    Bus.$on('denyRaiseHand', val => {
      this.haveUnRead = true;
    });
    Bus.$on('closePartiAudioMatrix', () => {
      this.participantAudioMatrix = false;
    });
    Bus.$on('shareScreenSetting', val => {
      const {
        frameRate,
        bitrate,
        resolution
      } = val;
      this.partyJoinInfo.status.shareScreenBitrate = bitrate;
      this.partyJoinInfo.status.shareScreenFrameRate = frameRate;
      this.partyJoinInfo.status.shareScreenResolution = resolution;
    });
    Bus.$on('showParticipantSetting', () => {
      this.showSettingPopup('', 'changeTab');
    });
    Bus.$on('hideChatMove', () => {
      this.State.batchMoveParticipate = false;
    });
  },
  watch: {
    partyJoinInfo: {
      handler: function (val) {
        if (val) {
          const {
            status
          } = val;
          this.selectPosition = status !== null && status !== void 0 && status.galleryCopySlotIndex ? status.galleryCopySlotIndex - 1 : '';
        }
      },
      deep: true
    },
    'State.fullScreen': {
      handler: function (val) {
        if (val) {
          this.fullRotate = true;
        } else {
          this.fullRotate = false;
        }
      }
    },
    'State.privateInfoByOthers': {
      // 目的是为了举手列表中，已经被其他host在私聊的与会者，不可以在于他进行私聊
      immediate: true,
      handler(newValue, oldValue) {
        const rtilCodes = newValue.map(v => v.rtilCode);
        this.raiseHandList && this.raiseHandList.forEach((v, index) => {
          if (rtilCodes.includes(v.rtilCode)) {
            v.disabled = true;
          } else {
            v.disabled = false;
          }
          this.$set(this.raiseHandList, index, v);
        });
      },
      deep: true
    },
    'State.checkEnv': {
      handler(newVal) {
        if (newVal.owner) {
          this.isHost = true;
        } else {
          this.isHost = false;
        }
      }
    },
    currentPartyInfo(val) {
      if (!val || !val.id) return;
      this.State.batchMoveParticipate = false;
      this.State.batchMoveParticipateList = [];
      this.State.showChatMessage = false;
      this.partyCode = val.code;
    },
    'joinInfo.status': function (val) {
      if (val.companyLogo) {
        const {
          id,
          url
        } = JSON.parse(val.companyLogo);
        this.useIconFontLogoInKiosk = false;
        this.logos = url;
        this.uploadLogoId = id;
      } else {
        this.logos = '';
        this.useIconFontLogoInKiosk = true;
      }
    }
  },
  computed: {
    ...mapState({
      State: state => state,
      joinLink: state => {
        var _state$config$urlInfo;
        return (_state$config$urlInfo = state.config.urlInfo) === null || _state$config$urlInfo === void 0 ? void 0 : _state$config$urlInfo.joinLink;
      },
      userInfo: state => state.loginInfo,
      config: state => state.config,
      partyJoinInfo: state => state.partyJoinInfo,
      loginInfo: state => state.loginInfo,
      currentPartyInfo: state => state.currentPartyInfo,
      layoutConfig: state => state.layoutConfig,
      joinInfo: state => state.joinInfo,
      logo: state => state.logo
    }),
    showMovePip() {
      const route = this.$route;
      return route.path.includes('/control') && route.name !== 'globalControl' && route.name !== 'intercom' && route.name !== 'interview';
    },
    joinModel() {
      if (this.$route.name == 'intercom') {
        return [{
          value: 0,
          label: 'Anyone with the link can join'
        }];
      } else {
        return [{
          value: 0,
          label: 'Anyone with the link can join'
        }, {
          value: 1,
          label: 'Only users added to the list can join'
        }, {
          value: 3,
          label: 'Anyone with passcode can join'
        }];
      }
    },
    returnGlobalFunList() {
      let array = [];
      const hasLogin = JSON.stringify(this.loginInfo) !== '{}';
      if (hasLogin) {
        if (this.partyJoinInfo.owner || this.$route.name === 'intercom') {
          this.serviceNameList = ['Producer'];
          array = ['waffle', 'account', 'helpCenter'];
        } else {
          array = ['account'];
        }
      }
      array.push('headerTime');
      // if (process.env.NODE_ENV === 'development') {
      //   array.push('downloadSpeed')
      // } else {
      //   array = array.concat(['downloadSpeed', 'networkDelay'])
      // }
      return array;
    },
    themeColor() {
      return handleLocalStorage('get', 'theme');
    },
    urlAddress() {
      const _this = this;
      const domain = window.location.host;
      this.isCoordinator = _this.partyCode.length === 9;
      return 'https://' + domain + '/partyline?join_id=' + this.partyCode + `${this.env ? '&env=' + this.env : ''}`;
    },
    firstWord() {
      const userInfo = this.userInfo.firstName || this.userInfo.email || '';
      if (userInfo[0]) {
        return userInfo.substring(0, 1);
      }
      return '';
    },
    getName() {
      const userInfo = this.userInfo;
      if (userInfo.firstName && userInfo.lastName) {
        return userInfo.firstName + ' ' + userInfo.lastName;
      } else if (userInfo.userName) {
        return userInfo.userName;
      } else {
        return userInfo.email ? userInfo.email.split('@')[0] : '';
      }
    },
    // 禁止打开与会者可以互相听到功能
    disabledFreeTalk() {
      let flag = false;
      if (this.$route.name.includes('group') && (this.State.privateInfo.crewRtilCode || this.State.privateInfoByOthers.length)) {
        flag = true;
      }
      if (this.$route.name.includes('group') && (this.State.galleryBroadcastInfo || this.State.gallerySpeakerInfo)) {
        flag = true;
      }
      return flag;
    },
    colorUp() {
      if (!this.netWork.upLinkNetWork) return '';
      if (this.netWork.upLinkNetWork === 'Good') {
        return 'colorGreen';
      } else if (this.netWork.upLinkNetWork === 'Mid') {
        return 'colorOrange';
      } else if (this.netWork.upLinkNetWork === 'Poor') {
        return 'colorRed';
      } else {
        return 'colorGreen';
      }
    },
    colorDown() {
      if (!this.netWork.downLinkNetWork) return '';
      if (this.netWork.downLinkNetWork === 'Good') {
        return 'colorGreen';
      } else if (this.netWork.downLinkNetWork === 'Mid') {
        return 'colorOrange';
      } else if (this.netWork.downLinkNetWork === 'Poor') {
        return 'colorRed';
      } else {
        return 'colorGreen';
      }
    },
    openUsagePage() {
      const usageServiceUrl = this.config.urlInfo.usageServiceUrl + '/?type=partyline&email=' + this.State.loginInfo.email + '&partycode=' + this.partyCode + '#/infoView';
      return usageServiceUrl;
    },
    showParticipantSetting() {
      return !this.isHost && (this.State.partiAudioMatrixEnable && this.State.partyJoinInfo.status.audioMatrix || this.State.participantPushTalkOpen && this.State.pushTalkOpen);
    },
    showEndBtn() {
      return (this.isHost || this.State.participantRole === 1 || this.State.participantRole === 2) && this.$route.name != 'globalControl' && this.$route.name != 'intercom';
    }
  },
  filters: {
    showJoinModel(value) {
      if (value === 0) {
        return i18n.t('invite.anyoneJoin');
      } else if (value === 1) {
        return i18n.t('invite.onlyUserJoin');
      } else if (value === 3) {
        return i18n.t('invite.onlyByPasscode');
      } else {
        return val;
      }
    }
  },
  methods: {
    getBackendVersion() {
      this.axios.get('/partyline-backend/publicApi/debug/version').then(res => {
        if (!res) return;
        const {
          errorCode
        } = res.data;
        let {
          result
        } = res.data;
        if (errorCode === '0x0') {
          handleLocalStorage('set', 'backendVersion', result);
          if (result && result.includes('_')) {
            result = result.substring(0, result.indexOf('_'));
          }
          this.backendVersion = result;
        }
      });
    },
    getCanBindEmail(item, searchKey) {
      this.axios.get(`/partyline-backend/user/email?email=${searchKey}`).then(res => {
        if (res.data.errorCode === '0x0') {
          item.emailList = res.data.result;
        }
      });
    },
    cancelBindEmail(item) {
      if (!this.partyCode) return;
      const params = {
        email: item.email,
        rtilCode: item.rtilCode,
        partyCode: this.partyCode,
        peerId: item.devicePeerId,
        startRtilCode: this.State.partyJoinInfo.rtilCode
      };
      this.axios.post('/partyline-backend/intercomPro/unbindStation', params).then(res => {
        if (res.data.errorCode === '0x0') {
          item.email = '';
        }
      });
    },
    gobackWorkBench() {
      routerJump('manage');
    },
    setCopySlot(slotNumber) {
      const params = {
        joinCode: this.partyCode,
        slotNumber: slotNumber + 1
      };
      this.axios.post('/partyline-backend/group/copySlot', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('setting.audioBackOperateSuccess'));
          Bus.$emit('changeSlotIndex', params.slotNumber);
        }
      });
    },
    showAddDeviceBox() {
      this.State.drawer = true;
      Bus.$emit('showAddDeviceBox');
    },
    showUplodImageBox() {
      Bus.$emit('showUplodImageBox');
    },
    getCurrentParty(item) {
      // 若 item 与当前 partyCode 匹配，则选中
      return item.partyCode === this.partyCode || item.groupId === this.partyCode || item.code === this.partyCode ? 'rgba(0, 0, 0, 0.3)' : '';
    },
    showTitle(item) {
      if (item.title) return item.title;
      return new Date(item.startPartyTime || item.createTime).toLocaleDateString() + '   ' + new Date(item.startPartyTime || item.createTime).toLocaleTimeString();
    },
    openPreviewPage(item) {
      var url = window.location.href;
      const partyCode = item.partyCode || item.groupId || item.code;
      if (partyCode == this.partyCode) return;
      var newUrl = url.replace(/id=\d+/, 'id=' + partyCode);
      window.location.href = newUrl;
    },
    openPartylist(init) {
      // 如果init没有则是滚动加载进来的页数要加1
      if (init) {
        this.partyPageInfo.pageNum = 1;
      } else {
        this.partyPageInfo.pageNum++;
        if (!this.partyPageInfo.hasNextPage) return;
      }
      this.partyListLoading = true;
      const requestInfo = {
        party: '/partyline-backend/party/page',
        group: '/partyline-backend/group/page',
        coordinator: '/partyline-backend/conference/page',
        kiosk: '/partyline-backend/kiosk/page'
      };
      const params = {
        pageSize: this.partyPageInfo.pageSize,
        pageNum: this.partyPageInfo.pageNum
      };
      this.axios.post(requestInfo[this.$route.name], params).then(res => {
        if (!res) return;
        const result = res.data.result;
        const list = result.list;
        this.partyPageInfo.hasNextPage = result.hasNextPage;
        this.partyListLoading = false;
        if (!init) {
          this.onlinePartyList = this.onlinePartyList.concat(list);
        } else {
          this.onlinePartyList = list;
        }
      });
    },
    topHeaderCallback(info) {
      const {
        type
      } = info;
      if (type === 'signOut') {
        this.logout();
      }
    },
    // co-host 相关代码开始
    // 打开cohost受邀弹窗
    getReceiverCoHostList() {
      this.getInvitedByOther('init');
    },
    getInvitedByOther(init) {
      if (!init && !this.receiverCohostPageInfo.hasNextPage) return;
      // 如果init没有则是滚动加载进来的页数要加1
      if (!init) this.receiverCohostPageInfo.pageNum++;
      const params = {
        invite: false,
        queryCollaborate: false,
        pageSize: this.receiverCohostPageInfo.pageSize,
        pageNum: this.receiverCohostPageInfo.pageNum
      };
      this.axios.post('/partyline-backend/collaborate/queryV2', params).then(res => {
        if (!res) return;
        const {
          errorCode,
          result
        } = res.data;
        if (errorCode === '0x0') {
          this.receiverCohostPageInfo.hasNextPage = result.hasNextPage;
          if (!init) {
            this.invitedMeList = this.invitedMeList.concat(result.list);
          } else {
            this.invitedMeList = result.list;
          }
          result.list.forEach(item => {
            item.select = '';
            item.color = this.returnColor(item);
          });
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    closeReceivedCohost() {
      this.State.receivedCohost = false;
      this.receiverCohostPageInfo.pageNum = 1;
    },
    // co-host 相关代码结束
    createQrCode() {
      this.qCode = QRCode.toDataURL(this.urlAddress).then(url => {
        this.qrCodeUrl = url;
      });
    },
    closeCollaborate() {
      this.collaboratePageInfo.pageNum = 1;
      this.receiverCollaboratePageInfo.pageNum = 1;
    },
    showReceivedPop() {
      this.showRightPop = false;
      this.State.receivedCohost = true;
      this.receivedCohost.show = true;
    },
    showInvitePop() {
      this.showInviteInfo.show = true;
      // 弹窗打开清空状态
      this.editPass = false;
      this.showErrorPassCode = false;
      this.createQrCode();
      this.getBindStation();
    },
    getBindStation() {
      this.axios.post('/partyline-backend/intercomPro/queryBindStation', {
        partyCode: this.partyCode
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          // 需要过滤返回的数据是否还在会议中
          const result = res.data.result;
          this.State.stationList.forEach(item => {
            result.forEach(resultItem => {
              if (item.rtilCode == resultItem.rtilCode) {
                item.email = resultItem.email;
              }
            });
          });
        }
      });
    },
    saveBindEmail(item) {
      const hostEamil = this.State.loginInfo.email;
      if (item.email == hostEamil) {
        item.email = '';
        this.$message.warning(this.$t('invite.canNotBandHostEmail'));
        return;
      }
      const params = {
        email: item.email,
        rtilCode: item.rtilCode,
        peerId: item.devicePeerId,
        partyCode: this.partyCode,
        startRtilCode: this.State.partyJoinInfo.rtilCode
      };
      this.axios.post('/partyline-backend/intercomPro/bindStation', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.$message.success('Operation success');
        } else {
          item.email = '';
        }
      });
    },
    showAudienceBox() {
      this.hideConferenceOperate('audience');
      this.showAudience = !this.showAudience;
      Bus.$emit('changeAudience', this.showAudience);
    },
    showRaiseHandList() {
      if (this.showRaiseHandTips) {
        this.haveUnRead = false;
      }
      this.hideConferenceOperate('raiseHand');
      this.showConferenceRaise = !this.showConferenceRaise;
      Bus.$emit('changeRaiseHand', this.showConferenceRaise);
    },
    controlPermission(val, rowInfo) {
      const params = {
        collaborateId: rowInfo.id,
        optionType: Number(val)
      };
      this.axios.post(`/partyline-backend/collaborate/updateStatusDirectly?collaborateId=${params.collaborateId}&optionType=${params.optionType}`, params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.invitedMeList.forEach(item => {
            if (item.userId == rowInfo.userId && params.collaborateId == item.id) {
              item.status = params.optionType;
              item.color = this.returnColor({
                status: params.optionType,
                collaborateEmail: item.userEmail
              });
            }
          });
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    showInvitedTime(invitedTime) {
      const year = new Date(invitedTime).getFullYear();
      let month = new Date(invitedTime).getMonth() + 1;
      let date = new Date(invitedTime).getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (date < 10) {
        date = '0' + date;
      }
      return year + '-' + month + '-' + date;
    },
    returnText(rowInfo) {
      let _str = '';
      if (rowInfo.status == 0) {
        _str = this.$t('personalInfo.inviting');
      } else if (rowInfo.status == 1) {
        _str = this.$t('personalInfo.accept');
      } else {
        _str = this.$t('personalInfo.declined');
      }
      return _str;
    },
    controlAudioOnly(val) {
      this.audioType = val;
      this.State.audioType = val;
      // 更改状态
      this.changeBehaviorStatus('audioOnlyType', val, this.State.partyJoinInfo.rtilCode);
      // 当所选择的值和当前不同时，在去更改订阅音视频状态
      Bus.$emit('subscribeAudioControl', val);
      if (val) {
        if (val == 1) {
          this.$message.success(this.$t('netWorkStatus.AllTimeAudioPopup'));
        } else {
          this.$message.success(this.$t('netWorkStatus.disabelAUdioPopup'));
        }
      }
    },
    controlMainWindow(val) {
      this.State.checkMainWindow = val;
      this.changeBehaviorStatus('checkAudioMainWindow', val, this.State.partyJoinInfo.rtilCode);
      Bus.$emit('dealMainAudioOnly', val);
    },
    controlShareScreen(val) {
      this.State.checkShareScreen = val;
      this.changeBehaviorStatus('checkAudioShare', val, this.State.partyJoinInfo.rtilCode);
      Bus.$emit('dealShareAudioOnly', val);
    },
    changeBehaviorStatus(key, value, id) {
      // 更新状态
      if (!id) return;
      const params = [{
        mark: id + '',
        annotation: this.$route.name === 'party' || this.$route.name === 'partyParticipate' ? this.State.partyJoinInfo.realPartyCode : this.State.partyJoinInfo.joinCode,
        key,
        value,
        notify: true
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params);
    },
    showSettingPopup(event, changeTab) {
      // 关闭move
      this.hideConferenceOperate('chat');
      this.showSetting = false;
      this.settingPopupInfo.show = true;
      if (changeTab) {
        this.$nextTick(() => {
          this.$refs.settingDialog.changeTabval('7');
        });
      }
      gtag('event', 'Show common setting', {
        event_category: 'setting',
        event_label: '会议设置',
        value: this.$route.name
      });
    },
    setPartiAudioMatrix() {
      this.participantAudioMatrix = true;
      Bus.$emit('setAudioMatrix', true);
    },
    controlSetting() {
      if (this.State.partiAudioMatrixEnable && !this.isHost && this.State.partyJoinInfo.status.audioMatrix) {
        this.setPartiAudioMatrix();
      } else {
        this.setPushToTalk();
      }
    },
    setPushToTalk() {
      var _this$$refs$settingDi;
      this.settingPopupInfo.show = true;
      (_this$$refs$settingDi = this.$refs.settingDialog) === null || _this$$refs$settingDi === void 0 ? void 0 : _this$$refs$settingDi.changeTabval('8');
    },
    closeSettingDialog() {
      this.settingPopupInfo.show = false;
    },
    // 切换邀请模式
    async showHadInvite(model) {
      // 清空模式三passcode
      this.passCodeVal = '';
      this.showInviteInfo.hideSave = true;
      if (model === 1) {
        await this.getHadInviteUser('showList');
      }
      if (model === 3) {
        await this.getHadInviteUser('showList');
        this.passCodeVal = this.createRandomPassCode();
      }
      this.setJoinWay();
    },
    createRandomPassCode() {
      let code = '';
      for (var i = 0; i < 6; i++) {
        const type = this.createRandom(1, 3);
        switch (type) {
          case 1:
            code += String.fromCharCode(this.createRandom(48, 57));
            break;
          case 2:
            code += String.fromCharCode(this.createRandom(65, 90));
            break;
          case 3:
            code += String.fromCharCode(this.createRandom(97, 122));
            break;
        }
      }
      return code;
    },
    createRandom(min, max) {
      return Math.round(Math.random() * (max - min) + min);
    },
    judgePassCode(passCode) {
      this.editPass = true;
      this.passCodeVal = passCode.replace(/[^\w\.\/]/ig, '');
      if (!this.passCodeVal || this.passCodeVal.length != 6) {
        this.showErrorPassCode = true;
      } else {
        this.showErrorPassCode = false;
      }
    },
    modifyPassWord(type) {
      if (!this.passCodeVal) {
        this.$message.warning(this.$t('invite.plsInpPasscode'));
        return;
      }
      if (this.passCodeVal.length != 6) {
        this.$message.warning(this.$t('invite.wrongPasscodeFormat'));
        return;
      }
      const params = {
        partyCode: this.partyCode,
        invitePassCode: this.passCodeVal
      };
      this.axios.post('/partyline-backend/partyExtendInfo', params).then(res => {
        if (!res) return;
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.showInviteInfo.show = false;
          if (type === 'byEnter') this.editPass = false;
          this.$message.success(this.$t('invite.inviteSetCopySuccess'));
        }
      });
    },
    changeEditVal() {
      setTimeout(() => {
        this.editPass = false;
      }, 200);
    },
    addInviteList(email) {
      if (this.searchName === this.State.loginInfo.email) {
        this.$message.warning(this.$t('personalInfo.forbidSetting'));
        return;
      }
      const hadInvite = this.isHadInvitedPass(this.searchName);
      if (hadInvite) return;
      if (email && this.searchName && this.isEmail(this.searchName)) {
        const obj = {};
        obj.name = this.searchName;
        obj.color = 'gray';
        this.willInviteList.push(obj);
      }
      this.willInviteList = [...new Set(this.willInviteList)];
      // 转移save逻辑到add(邀请email)
      this.setJoinWay();
    },
    deleteInvite(email) {
      const params = {
        emailList: [email],
        partyCode: this.partyCode
      };
      this.axios.delete('/partyline-backend/partyExtendInfo/emails', {
        data: params
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.$message.success(this.$t('invite.inviteDeleteSuccess'));
          this.getHadInviteUser('showList');
        }
      });
    },
    deleteCollaborateInvite(userId, index) {
      const params = {
        userIds: [userId]
      };
      this.axios.delete('/partyline-backend/collaborate', {
        data: params
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          const _this = this;
          if (_this.collaboratePageInfo.pageNum == 1 && _this.collaboratePageInfo.hasNextPage) {
            this.getCollaborateHadInvite('init');
          } else {
            this.hadInviteCollaborate.splice(index, 1);
            this.State.hadInvitedList.splice(index, 1);
          }
          if (_this.collaboratePageInfo.pageNum == 1) {
            this.hadInvite.splice(index, 1);
          }
          this.$message.success(this.$t('invite.inviteDeleteSuccess'));
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      });
    },
    deleteCollaborateByOtherInvite(rowInfo) {
      const params = {
        userIds: [rowInfo.userId],
        invite: false
      };
      this.axios.delete('/partyline-backend/collaborate', {
        data: params
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          if (this.receiverCollaboratePageInfo.pageNum == 1 && this.receiverCollaboratePageInfo.hasNextPage) {
            this.getInvitedByOhter('init');
          } else {
            this.invitedMeList.forEach((item, index) => {
              if (item.userId == rowInfo.userId) {
                this.invitedMeList.splice(index, 1);
              }
            });
          }
          this.$message.success(this.$t('invite.inviteDeleteSuccess'));
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      });
    },
    removeInvite(index) {
      this.willInviteList.splice(index, 1);
    },
    removeCollaborateInvite(index) {
      this.willInviteCollaborate.splice(index, 1);
    },
    isEmail(val) {
      var regEmail = /^([a-zA-Z0-9_\-\.])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (val && !regEmail.test(val)) {
        this.showErrorEmailText = true;
        this.$refs.emailInput.$el.children[0].focus();
        return false;
      }
      return true;
    },
    // 判断是否已经存在于列表中(邀请passcode)
    isHadInvitedPass(email) {
      let flag = false;
      this.willInviteList.forEach(item => {
        if (item.name == email) {
          flag = true;
        }
      });
      this.hadInviteList.forEach(info => {
        if (info.name == email && info.status != 2) {
          flag = true;
        }
      });
      if (flag) {
        this.$message.warning(this.$t('personalInfo.hadInvited'));
      }
      return flag;
    },
    // 判断是否已经存在于列表中(协作)
    isHadInvited(email) {
      let flag = false;
      this.willInviteCollaborate.forEach(item => {
        if (item.name == email) {
          flag = true;
        }
      });
      this.hadInviteCollaborate.forEach(info => {
        if (info.collaborateEmail == email && info.status != 2) {
          flag = true;
        }
      });
      if (flag) {
        this.$message.warning(this.$t('personalInfo.hadInvited'));
      }
      return flag;
    },
    // 邀请功能的
    async getHadInviteUser(showList) {
      // 清空之前的状态
      this.searchName = '';
      this.showErrorEmailText = false;
      this.willInviteList = [];
      await this.axios.get(`/partyline-backend/partyExtendInfo/${this.partyCode}`).then(res => {
        if (!res) return;
        const {
          errorCode,
          result
        } = res.data;
        if (errorCode === '0x0') {
          const array = [];
          result.emailList.forEach(user => {
            const obj = {};
            obj.name = user;
            obj.color = userBgColor(user);
            array.push(obj);
          });
          this.hadInviteList = array;
          this.passCodeVal = result.invitePassCode;
          // 切换模式的时候不需要更改值
          if (!showList) {
            this.selectModule = result.inviteMode;
          }
        }
      });
    },
    getInvitedList(tab) {
      if (!tab || tab.name === 'invitedOther' || this.selectType === 'invitedOther') {
        this.collaboratePageInfo.pageNum = 1;
        this.collaborateInfo.hideSave = true;
        this.getCollaborateHadInvite('init');
      } else {
        this.receiverCollaboratePageInfo.pageNum = 1;
        this.collaborateInfo.hideSave = true;
        this.getInvitedByOhter('init');
      }
    },
    // 协作功能的
    async getCollaborateHadInvite(init) {
      if (!init && !this.collaboratePageInfo.hasNextPage) return;
      // 如果init没有则是滚动加载进来的页数要加1
      if (!init) this.collaboratePageInfo.pageNum++;
      // 清空之前的状态
      this.collaborateSearchName = '';
      this.showErrorEmailText = false;
      this.willInviteCollaborate = [];
      if (this.collaboratePageInfo.pageNum == 1) {
        this.hadInvite = [];
      }
      const params = {
        invite: true,
        queryCollaborate: true,
        pageSize: this.collaboratePageInfo.pageSize,
        pageNum: this.collaboratePageInfo.pageNum
      };
      await this.axios.post('/partyline-backend/collaborate/queryV2', params).then(res => {
        if (!res) return;
        const {
          errorCode,
          result
        } = res.data;
        if (errorCode === '0x0') {
          this.collaboratePageInfo.hasNextPage = result.hasNextPage;
          if (this.collaboratePageInfo.pageNum == 1) {
            const hadInviteArray = [];
            result.list.forEach((info, index) => {
              if (index < 3) {
                info.color = this.returnColor(info);
                hadInviteArray.push({
                  label: info.collaborateEmail.slice(0, 1),
                  email: info.collaborateEmail
                });
              }
            });
            this.hadInvite = hadInviteArray;
          }
          if (!init) {
            this.hadInviteCollaborate = this.hadInviteCollaborate.concat(result.list);
            this.State.hadInvitedList = this.hadInviteCollaborate.concat(JSON.parse(JSON.stringify(result.list)));
          } else {
            this.hadInviteCollaborate = result.list;
            this.State.hadInvitedList = JSON.parse(JSON.stringify(result.list));
          }
          // this.hadInviteCollaborate = result
          // this.State.hadInvitedList = JSON.parse(JSON.stringify(result))
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getInvitedByOhter(init) {
      if (!init && !this.receiverCollaboratePageInfo.hasNextPage) return;
      // 如果init没有则是滚动加载进来的页数要加1
      if (!init) this.receiverCollaboratePageInfo.pageNum++;
      const params = {
        invite: false,
        queryCollaborate: true,
        pageSize: this.receiverCollaboratePageInfo.pageSize,
        pageNum: this.receiverCollaboratePageInfo.pageNum
      };
      this.axios.post('/partyline-backend/collaborate/queryV2', params).then(res => {
        if (!res) return;
        const {
          errorCode,
          result
        } = res.data;
        if (errorCode === '0x0') {
          this.receiverCollaboratePageInfo.hasNextPage = result.hasNextPage;
          result.list.forEach(item => {
            item.select = '';
            item.color = this.returnColor(item);
          });
          if (!init) {
            this.invitedMeList = this.invitedMeList.concat(result.list);
          } else {
            this.invitedMeList = result.list;
          }
          // this.invitedMeList = result
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    returnColor(info) {
      const {
        status
      } = info;
      if (status === 0 || status === 2) {
        return 'gray';
      } else if (status === 1) {
        return userBgColor(info.collaborateEmail);
      }
    },
    changeFreeTalk() {
      let url = '';
      if (!this.freeTalk) {
        url = `/partyline-backend/group/cancelFreeTalk/${this.currentPartyInfo.code}`;
      } else {
        url = `/partyline-backend/group/setFreeTalk/${this.currentPartyInfo.code}`;
      }
      this.axios.post(url);
    },
    pageFullScreen() {
      Bus.$emit('wholePageFullScreen', true);
      this.showFullScreen = !this.showFullScreen;
    },
    hideOtherOperate() {
      // 隐藏chat/move
      this.State.showChatMessage = false;
      this.State.batchMoveParticipate = false;
    },
    hideConferenceOperate(type) {
      if (type === 'audience') {
        this.State.showChatMessage = false;
        this.showConferenceRaise = false;
        Bus.$emit('changeRaiseHand', false);
        this.State.batchMoveParticipate = false;
      } else if (type === 'raiseHand') {
        this.State.showChatMessage = false;
        this.showAudience = false;
        Bus.$emit('changeAudience', this.showAudience);
        this.State.batchMoveParticipate = false;
      } else if (type === 'chat') {
        Bus.$emit('changeRaiseHand', false);
        this.State.batchMoveParticipate = false;
        this.showAudience = false;
        Bus.$emit('changeAudience', this.showAudience);
      } else {
        this.showAudience = false;
        this.State.showChatMessage = false;
        this.showConferenceRaise = false;
        Bus.$emit('changeRaiseHand', false);
        Bus.$emit('changeAudience', this.showAudience);
      }
    },
    movePips() {
      this.State.showChatMessage = false;
      this.State.batchMoveParticipate = !this.State.batchMoveParticipate;
      this.hideConferenceOperate();
    },
    getNickName(id) {
      if (!this.groupId) return;
      this.axios.post('/partyline-backend/behavior/noLogin/getList', {
        originRtilCode: this.userInfo.rtilCode,
        annotation: this.groupId,
        keys: ['nickName', 'tagName'],
        marks: [id]
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result[id];
          this.$set(this.tagNameInfo, id, result.tagName);
          if (this.State.galleryBroadcastInfo && this.State.galleryBroadcastInfo.rtilCode == id) {
            this.State.galleryBroadcastInfo.tagName = result.tagName;
          }
          if (this.vfbVideoInfo && this.vfbVideoInfo.rtilCode == id) {
            this.vfbVideoInfo.tagName = result.tagName;
          }
        }
      });
    },
    getReplace() {
      this.hideOtherOperate();
      if (!this.partyCode) return;
      this.axios.get(`/partyline-backend/group/noLogin/getFullInRule/${this.partyCode}`).then(res => {
        const result = res.data;
        if (result.errorCode === '0x0') {
          this.replaceIndex = result.result;
        }
      });
    },
    setReplace(index) {
      if (!this.partyCode) return;
      this.selectPosition = '';
      const params = {
        rule: index,
        groupId: this.partyCode
      };
      this.axios.post('/partyline-backend/group/noLogin/updateFullInRule', params).then(res => {
        const result = res.data;
        if (result.errorCode === '0x0') {
          this.replaceIndex = index;
          this.$message({
            type: 'success',
            message: this.$t('galleryHost.setSuccess')
          });
          Bus.$emit('changeFillRule', index);
        }
      });
    },
    getRealPartyCode(rtilCode, rtcClient) {
      this.axios.get(`/partyline-backend/group/noLogin/rtilCodeInPartyCode?groupId=${this.partyCode}&rtilCode=${rtilCode}`).then(async res => {
        if (res.data.errorCode === '0x0') {
          const realPartyCode = res.data.result;
          if (rtcClient[realPartyCode]) {
            if (rtcClient[realPartyCode]._localStream) {
              rtcClient[realPartyCode]._localStream.unmuteAudio();
            }
          } else {
            this.joinPartyLine(realPartyCode, rtilCode, rtcClient);
          }
        }
      });
    },
    joinPartyLine(partyCode, rtilCode, rtcClient) {
      const params = {
        memberId: handleLocalStorage('get', 'galleryMemberId'),
        partyCode: partyCode,
        role: 0,
        type: 3
      };
      this.axios.post('/partyline-backend/party/v2/noLogin/agoraTokenGenerate', params).then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          const param = {
            ...result,
            memberId: params.memberId,
            partyCode: partyCode
          };
          this.getMeetingInfo(param, rtilCode, rtcClient);
        }
      });
    },
    async getMeetingInfo(param, recRtilCode, rtcClient) {
      const {
        appId,
        tokenCode,
        rtilCode,
        realPartyCode
      } = param;
      const params = {
        appId,
        channel: realPartyCode + '',
        token: tokenCode,
        mode: 'live',
        codec: 'vp8',
        uid: rtilCode,
        audioSource: true,
        domId: 'local_stream1',
        streamAdd: [recRtilCode],
        isShowlocalStream: true,
        publishVideo: false,
        publishAudio: true,
        video: false,
        audio: true
      };
      if (this.rtc) await this.rtc.leave();
      this.rtc = new AgoraRTCClient(this.callBack);
      // 为了当 host 切换到第二页时 index.vue 里面没有保存私聊的 party
      if (rtcClient) {
        this.$set(rtcClient, params.channel, this.rtc);
      }
      this.State.rtcList[realPartyCode] = this.rtc;
      await this.rtc.join(params);
    },
    callBack({
      action,
      payload
    }) {
      switch (action) {
        case 'subscribe-track':
          this.addView(payload);
          break;
        case 'user-published':
        case 'user-unpublished':
          this.muteAudioOrVideo(action, payload);
          break;
      }
    },
    addView(payload) {
      try {
        // 创建可以播放的mediastream
        const {
          videoTrack,
          audioTrack
        } = payload;
        const privateMedia = new MediaStream();
        if (videoTrack) {
          if (videoTrack._mediaStreamTrack instanceof MediaStreamTrack) {
            privateMedia.addTrack(videoTrack._mediaStreamTrack);
          }
        }
        if (audioTrack) {
          if (audioTrack._mediaStreamTrack instanceof MediaStreamTrack) {
            privateMedia.addTrack(audioTrack._mediaStreamTrack);
          }
        }
        const obj = {};
        obj.id = payload.id;
        obj.channel = payload.channel;
        obj.stream = privateMedia;
        obj.videoTrack = videoTrack;
        obj.audioTrack = audioTrack;
        this.raiseHandStream = obj;
      } catch (error) {}
    },
    muteAudioOrVideo(action, payload) {
      const {
        id
      } = payload;
      if (action === 'user-unpublished') {
        if (payload.mediaType === 'video') {
          this.$set(this.State.cameraStatus, id, false);
        } else {
          this.$set(this.State.micStatus, id, false);
        }
      } else {
        if (payload.mediaType === 'video') {
          this.$set(this.State.cameraStatus, id, true);
        } else {
          this.$set(this.State.micStatus, id, true);
        }
      }
    },
    initRaiseHandList(init) {
      if (!this.$route.name.includes('group') || !this.partyCode) return;
      this.hideOtherOperate();
      this.axios.get(`/partyline-backend/group/noLogin/raiseHandList/${this.partyCode}`).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          result.forEach((item, index) => {
            item.talkStatus = 'talk';
            item.disabled = false;
            // 初始化判断举手列表的人是否已经存在私聊
            this.State.privateInfoByOthers.forEach(v => {
              if (v.rtilCode == item.rtilCode) {
                item.disabled = true;
              }
            });
            if (!init && this.State.privateInfo.rtilCode) {
              if (item.talking || this.State.privateInfo.rtilCode == item.rtilCode) {
                item.talkStatus = 'hangUp';
                this.raisePrivateName = item.name;
              }
            }
            item.info = {};
            item.info.groupId = this.partyCode;
            item.info.name = item.name;
            item.info.rtilCode = item.rtilCode;
            item.info.realPartyCode = item.realPartyCode;
            item.info.partyList = this.State.groupInfo ? this.State.groupInfo.partyCodeList : [];
          });
          this.raiseHandList = result;
        }
      });
    },
    showEditInput() {
      if (this.$route.name == 'globalControl') return;
      const manageRtil = this.userInfo.managerRtils;
      if (manageRtil && !manageRtil.includes(this.State.currentRtilCode)) return;
      this.showUrlText = !this.showUrlText;
      this.inputUrlText = this.urlTextInfo;
      this.$nextTick(() => {
        this.$refs.partyInput.$refs.input.focus();
        this.$refs.partyInput.$refs.input.select();
      });
    },
    changePartyName() {
      this.showUrlText = !this.showUrlText;
      if (!this.inputUrlText) {
        return;
      }
      const requestInfo = {
        party: '/partyline-backend/commonParty/updateTitle',
        group: '/partyline-backend/group/updateTitle',
        coordinator: '/partyline-backend/conference/updateTitle',
        kiosk: '/partyline-backend/kiosk/updateTitle'
      };
      const params = {
        id: this.currentPartyInfo.id,
        title: this.inputUrlText,
        _partyCode: this.partyCode
      };
      this.axios.post(requestInfo[this.$route.name], params).then(res => {
        if (!res) return;
        if (res.data.errorCode == '0x0') {
          this.urlTextInfo = this.inputUrlText;
          this.$message.success(this.$t('galleryHost.renameParty'));
        } else {
          this.$message.error(this.$t('galleryHost.renamePartyFailed'));
        }
      });
    },
    urlText(partyCode, index) {
      const partyIdStr = this.$t('commonPartyHost.topContent.partyId') + ': ' + this.$options.filters.returnStrByInfo(partyCode, index);
      const partyOwnerStr = this.$t('commonPartyHost.topContent.partyOwner') + ': ' + (this.State.checkEnv.userEmail || this.State.loginInfo.email);
      return `${partyIdStr}<br>${partyOwnerStr}`;
    },
    removeV3(v) {
      const params = {
        peerId: v.peerId,
        partyCode: this.partyCode
      };
      this.axios.post('/partyline-backend/party/packLeave', params).then(res => {
        if (res.data.errorCode != '0x0') {
          this.$message({
            type: 'error',
            message: res.data.errorInfo
          });
        }
      });
    },
    endCurrentParty() {
      this.endInfo.show = true;
      this.endInfo.content = `<div class="end">${this.$t('endParty.content1')}<p>${this.$t('endParty.content2')}</p></div>`;
      gtag('event', 'End party', {
        event_category: '结束会议',
        event_label: '结束会议'
      });
    },
    saveEnd() {
      if (!this.partyCode) return;
      this.axios.post(`/partyline-backend/partyAction/endParty?partyCode=${this.partyCode}&key=26891`).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('galleryHost.endedPartySuccess'));
        }
      });
    },
    shareScreen() {
      Bus.$emit('startOrStopShare');
    },
    showOrHide() {
      this.flag = !this.flag;
      Bus.$emit('configPartyList', this.flag);
    },
    onCopy() {
      this.$message({
        message: this.$t('copy.onCopy'),
        type: 'success'
      });
    },
    login() {
      var _this$config$urlInfo;
      const userServerUrl = (_this$config$urlInfo = this.config.urlInfo) === null || _this$config$urlInfo === void 0 ? void 0 : _this$config$urlInfo.userservice;
      const serverName = this.config.serverName;
      const isCommentator = window.location.href.includes('commentator');
      const programName = this.State.publicPath || 'partyline';
      if (isCommentator) {
        window.location.href = `${userServerUrl}/?url=${location.protocol}//${location.host}/${programName}/partycode/${this.partyCode}&module=commentator&byLogin=true&serviceName=${serverName}`;
      } else {
        window.location.href = `${userServerUrl}/?url=${location.protocol}//${location.host}/${programName}/partycode/${this.partyCode}&byLogin=true&serviceName=${serverName}`;
      }
    },
    logout() {
      this.axios.get('/partyline-backend/user/logout').then(res => {
        if (!res) return;
        if (res.data.errorCode == '0x0') {
          this.$store.commit('jumpLoginPage');
        }
      });
    },
    onPassCodeCopy() {
      if (!this.partyCode) return;
      if (!this.isEmail(this.searchName)) return;
      if (!this.passCodeVal && this.selectModule === 3 && this.passCodeVal.length != 6) {
        this.$message.warning(this.$t('invite.plsInpPasscode'));
        return;
      }
      const inviteList = [];
      this.willInviteList.forEach(user => {
        const obj = {};
        obj.memberEmail = user.name;
        obj.partyCode = this.partyCode;
        inviteList.push(obj);
      });
      // 只添加一个走这里
      if (!this.willInviteList.length && this.searchName) {
        inviteList.push({
          memberEmail: this.searchName,
          partyCode: this.partyCode
        });
      }
      const linkUrl = 'https://' + window.location.host + '/partyline?join_id=' + this.partyCode + `${this.env ? '&env=' + this.env : ''}`;
      const params = {
        inviteMode: this.selectModule,
        partyCode: this.partyCode,
        emailNotification: this.sendEmail ? 1 : 0,
        linkUrl: linkUrl,
        partyInviteMemberList: !this.selectModule ? [] : inviteList,
        invitePassCode: this.passCodeVal ? this.passCodeVal : ''
      };
      this.axios.post('/partyline-backend/partyExtendInfo', params, {
        errorTip: false
      }).then(res => {
        const {
          errorCode,
          errorInfo
        } = res.data;
        if (errorCode === '0x0') {
          this.showInviteInfo.show = false;
          this.searchName = '';
          if (!params.inviteMode) this.hadInviteList = [];
          this.$message.success(this.$t('invite.inviteSetCopySuccess'));
        } else if (errorCode === '9000002') {
          this.$message.warning(this.$t('personalInfo.forbidSetting'));
        } else if (errorCode === '80520105') {
          this.$message.error(params.partyInviteMemberList[0].memberEmail + this.$t('invite.alreadyInvited'));
        } else {
          this.$message.error(errorInfo);
        }
      });
    },
    onError() {
      this.$message({
        message: this.$t('copy.onError'),
        type: 'error'
      });
    },
    leaveParty() {
      this.dialogTableVisible = true;
    },
    leave() {
      routerJump('joinOrStart');
      // todo 现在这个接口没有调用没有 rtilcode 等后端接口兼容了再去调
      const params = {
        partyCode: this.State.partyCode,
        module: 'leaveParty',
        msg: {
          rtilCode: this.leavePartyInfo.rtilCode,
          realPartyCode: this.leavePartyInfo.realPartyCode,
          externalParty: this.leavePartyInfo.externalParty,
          slotNum: Number(this.leavePartyInfo.slotNum),
          receiverCodeList: this.leavePartyInfo.receiverCodeList
        }
      };
      if (!params.partyCode || !params.msg.rtilCode) return;
      this.axios.post('/partyline-backend/party/noLogin/command?key=11260', params).then(res => {});
    },
    changeLayout(layout) {
      Bus.$emit('updateLayout', layout);
    },
    refuseConversation(item, notShow) {
      if (!notShow && item.talkStatus != 'talk' || item.disabled) return;
      const params = {
        partyCode: item.info.groupId,
        module: 'denyRaiseHand',
        msg: {
          name: item.name,
          rtilCode: item.info.rtilCode,
          realPartyCode: item.info.realPartyCode
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=30353', params).then(res => {
        if (res.data.errorCode == '0x0') {
          if (!notShow) {
            this.$message({
              type: 'success',
              message: this.$t('galleryHost.privateRequestRemove')
            });
          }
        }
      });
    },
    setPrivateChat(item) {
      if (this.privateLoading === true) return;
      this.privateLoading = true;
      // 判断当前是startPublicChat还是stopPublicChat
      if (item.talkStatus === 'hangUp') {
        this.stopPrivateChat(item);
      } else {
        // 判断当前是否有在talk
        this.selectPublicChatInfo = item;
        if (this.State.privateInfo.rtilCode) {
          this.publicInfo.show = true;
        } else {
          this.startPrivateChat(item);
        }
      }
    },
    startPrivateChat(item, hasCancelLast) {
      const params = {
        partyCode: item.info.partyCode || this.partyCode,
        module: 'startPrivateConversation',
        msg: {
          name: item.nickName,
          rtilCode: item.info.rtilCode,
          type: 'raiseHand',
          crewRtilCode: this.State.currentRtilCode,
          realPartyCode: item.info.realPartyCode,
          groupId: item.partyCode || this.partyCode,
          byRaiseHand: true,
          partyList: this.State.groupInfo ? this.State.groupInfo.partyCodeList : []
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=14273', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.State.privateInfo = params.msg;
          // item.talkStatus = 'hangUp'
          this.$message({
            type: 'success',
            message: this.$t('galleryHost.privateRequestSet')
          });
          if (hasCancelLast) this.selectPublicChatInfo = null;
        } else {
          this.selectPublicChatInfo = null;
        }
        this.privateLoading = false;
      });
    },
    stopPrivateChat(item) {
      const params = {
        partyCode: item.info.groupId,
        module: 'cancelPrivateConversation',
        msg: {
          name: item.name,
          rtilCode: item.info.rtilCode,
          crewRtilCode: this.State.currentRtilCode,
          realPartyCode: item.info.realPartyCode,
          hadCancelRaiseHand: true,
          partyList: this.State.groupInfo ? this.State.groupInfo.partyCodeList : []
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=45575', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.selectPublicChatInfo = null;
          this.State.privateInfo = {};
          if (!this.State.galleryPartyCodeList.includes(item.info.realPartyCode)) {
            this.rtc && this.rtc.leave();
          }
          this.refuseConversation(item, 'notShow');
          this.$message({
            type: 'success',
            message: this.$t('galleryHost.privateChatHungUp')
          });
        }
        this.privateLoading = false;
      });
    },
    switchPrivate() {
      this.cancelOldPri();
    },
    cancelOldPri() {
      const params = {
        partyCode: this.State.privateInfo.groupId || this.partyCode,
        module: 'cancelPrivateConversation',
        msg: {
          name: this.State.privateInfo.name,
          crewRtilCode: this.State.currentRtilCode,
          rtilCode: this.State.privateInfo.rtilCode,
          realPartyCode: this.State.privateInfo.realPartyCode,
          groupId: this.State.privateInfo.groupId || this.partyCode,
          partyList: this.State.groupInfo ? this.State.groupInfo.partyCodeList : []
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=56240', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.publicInfo.show = false;
          this.State.privateInfo = {};
          if (!this.State.galleryPartyCodeList.includes(this.State.privateInfo.realPartyCode)) {
            this.rtc && this.rtc.leave();
          }
          this.startPrivateChat(this.selectPublicChatInfo, 'hasCancelLast');
        }
      });
    },
    changeLanguage(lang) {
      Cookie.set('userLanguage', lang, {
        domain: '.tvunetworks.com'
      });
      this.$i18n.locale = lang;
      this.State.browserLanguage = lang;
    },
    changeParticipantLanguage() {
      if (this.$i18n.locale === 'zh' || this.$i18n.locale === 'zh-CN') {
        Cookie.set('userLanguage', 'en', {
          domain: '.tvunetworks.com'
        });
        this.$i18n.locale = 'en';
        this.State.browserLanguage = 'en';
      } else {
        Cookie.set('userLanguage', 'zh', {
          domain: '.tvunetworks.com'
        });
        this.$i18n.locale = 'zh';
        this.State.browserLanguage = 'zh';
      }
    },
    checkInputText(val) {
      if (this.inputTimer) clearTimeout(this.inputTimer);
      const _this = this;
      this.inputTimer = setTimeout(() => {
        var regEmail = /^([a-zA-Z0-9_\-\.])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        if (val && !regEmail.test(val)) {
          this.showErrorEmailText = true;
          _this.$refs.emailInput.$el.children[0].focus();
        } else {
          this.showErrorEmailText = false;
        }
      }, 800);
    },
    setJoinWay(Add) {
      if (!this.partyCode) return;
      if (!this.isEmail(this.searchName)) return;
      if (!this.passCodeVal && this.selectModule === 3 && this.passCodeVal.length != 6) {
        this.$message.warning(this.$t('invite.plsInpPasscode'));
        return;
      }
      const inviteList = [];
      this.willInviteList.forEach(user => {
        const obj = {};
        obj.memberEmail = user.name;
        obj.partyCode = this.partyCode;
        inviteList.push(obj);
      });
      // 只添加一个走这里
      if (!this.willInviteList.length && this.searchName) {
        inviteList.push({
          memberEmail: this.searchName,
          partyCode: this.partyCode
        });
      }
      const linkUrl = 'https://' + window.location.host + '/partyline?join_id=' + this.partyCode + `${this.env ? '&env=' + this.env : ''}`;
      const params = {
        inviteMode: this.selectModule,
        partyCode: this.partyCode,
        emailNotification: this.sendEmail ? 1 : 0,
        linkUrl: linkUrl,
        partyInviteMemberList: !this.selectModule ? [] : inviteList,
        invitePassCode: this.passCodeVal ? this.passCodeVal : ''
      };
      this.axios.post('/partyline-backend/partyExtendInfo', params, {
        errorTip: false
      }).then(res => {
        const {
          errorCode,
          errorInfo
        } = res.data;
        if (errorCode === '0x0') {
          this.searchName = '';
          if (!params.inviteMode) this.hadInviteList = [];
          this.$message.success(this.$t('invite.inviteSetSuccess'));
        } else if (errorCode === '9000002') {
          this.$message.warning(this.$t('personalInfo.forbidSetting'));
        } else if (errorCode === '80520105') {
          this.$message.error(params.partyInviteMemberList[0].memberEmail + this.$t('invite.alreadyInvited'));
        } else {
          this.$message.error(errorInfo);
        }
      });
    },
    saveCollaborate(email) {
      if (!this.collaborateSearchName) {
        this.$message.warning(this.$t('personalInfo.noInvitedEmai'));
        this.collaborateInfo.show = true;
        return false;
      }
      if (!this.partyCode || this.selectType != 'invitedOther') return;
      if (!this.isEmail(this.collaborateSearchName)) return;
      if (this.collaborateSearchName === this.State.loginInfo.email) {
        this.$message.warning(this.$t('personalInfo.forbidSetting'));
        return;
      }
      if (this.isHadInvited(this.collaborateSearchName)) return;
      const params = {
        collaborateUserEmailList: [this.collaborateSearchName]
      };
      this.axios.post('/partyline-backend/collaborate', params, {
        errorTip: false
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          if (email && this.collaborateSearchName && this.isEmail(this.collaborateSearchName) && !this.isHadInvited(this.collaborateSearchName)) {
            const obj = {};
            obj.name = this.collaborateSearchName;
            obj.color = 'gray';
            this.willInviteCollaborate.push(obj);
          }
          this.willInviteCollaborate = [...new Set(this.willInviteCollaborate)];
          this.collaborateSearchName = '';
          this.getCollaborateHadInvite();
          this.$message.success(this.$t('personalInfo.hostSaveSuccess'));
          // 关闭弹窗
          this.collaborateInfo.show = false;
        } else if (errorCode === '9000002') {
          this.$message.warning(this.$t('personalInfo.forbidSetting'));
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      });
    },
    showCollaborate() {
      this.collaborateInfo.show = true;
    },
    //  左上角替换 logo 代码逻辑
    showUploadLogo() {
      this.uploadLogoVisible = true;
    },
    handleChange(file) {
      this.uploadFile = file;
    },
    // 上传到s3
    uploadFileBySDK() {
      this.uploadLogoLoading = true;
      const params = {
        region: handleLocalStorage('get', 'region'),
        service: 'pp',
        // directoryName: '/Partyline/kiosk/companyLogo',
        directoryName: `/Partyline/kiosk/companyLogo/${this.State.partyCode}`,
        fileName: this.uploadFile.name
      };
      if (this.$route.name.includes('kiosk')) {
        params.directoryName = `/Partyline/kiosk/${this.State.partyCode}/companyLogo`;
      } else if (this.$route.name.includes('coordinator')) {
        params.directoryName = `/Partyline/conference/${this.State.partyCode}/companyLogo`;
      }
      this.axios.post('/file/request-upload-for-sdk', params, {
        requestBase: 'GATEWAY'
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.uploadParams = result;
          AWS.config.region = result.identityPoolRegion;
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: result.identityPoolId
          });
          this.doUploadFile(this.uploadFile);
        } else {
          this.uploadLogoLoading = false;
        }
      });
    },
    doUploadFile(obj) {
      this.uploadObj = new AWS.S3.ManagedUpload({
        params: {
          Bucket: this.uploadParams.bucket,
          Key: this.uploadParams.objectKey,
          Body: obj.raw,
          ACL: 'public-read'
        },
        service: new AWS.S3({
          region: this.uploadParams.region
        })
      });
      this.uploadObj.promise().then(data => {
        this.saveResult();
      });
    },
    saveResult() {
      const params = {
        bucketId: this.uploadParams.bucketId,
        directoryId: this.uploadParams.directoryId,
        objectKey: this.uploadParams.objectKey
      };
      this.axios.post('/file/add-file', params, {
        requestBase: 'GATEWAY'
      }).then(async res => {
        if (res.data.errorCode === '0x0') {
          this.uploadLogoLoading = false;
          this.uploadLogoId = res.data.result;
          const id = res.data.result;
          this.uploadLogoVisible = false;
          this.$message.success(this.$t('kioskHost.saveSuccess'));
          // 获取当前的 logo list
          await this.getUploadLogo();
          let willSendInfo = {};
          // 判断是否有之前上传的 logo
          const _this = this;
          _this.uploadLogoList.forEach(item => {
            if (id === item.id) {
              this.useIconFontLogoInKiosk = false;
              this.logos = item.url;
              willSendInfo = item;
            } else {
              this.deleteUpload(item, false);
            }
          });
          this.sendUploadToParticipant(willSendInfo);
        } else {
          this.uploadLogoLoading = false;
        }
      });
    },
    async getUploadLogo(id) {
      if (this.$route.name.includes('kiosk')) {
        this.getUploadParams.directoryName = `/Partyline/kiosk/${this.State.partyCode}/companyLogo/`;
      } else if (this.$route.name.includes('coordinator')) {
        this.getUploadParams.directoryName = `/Partyline/conference/${this.State.partyCode}/companyLogo`;
      }
      await this.axios.post('/file/query-user-files', this.getUploadParams, {
        requestBase: 'GATEWAY'
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.uploadLogoList = res.data.result.records;
        }
      });
    },
    deleteUpload(item, sendToParticipant = true) {
      const params = {
        id: item.id
      };
      this.axios.post('/file/delete', params, {
        requestBase: 'GATEWAY'
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.uploadLogoVisible = false;
          if (sendToParticipant) {
            this.uploadLogoId = '';
            this.sendDeleteToParticipant();
          }
          const _this = this;
          _this.uploadLogoList.forEach((val, index) => {
            if (val.id == item.id) {
              _this.uploadLogoList.splice(index, 1);
            }
          });
        }
      });
    },
    sendUploadToParticipant(info) {
      const params = {
        id: info.id,
        url: info.url,
        name: info.name,
        active: true
      };
      this.axios.post(`/partyline-backend/partyAction/setCompanyLogo?partyCode=${this.State.partyCode}&key=43091`, params).then(res => {});
    },
    sendDeleteToParticipant() {
      const params = {
        partyCode: this.State.partyCode,
        module: 'cancelCompanyLogo',
        msg: {}
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=43091', params).then(res => {
        if (res.data.errorCode === '0x0') {}
      });
    },
    // 恢复默认 logo
    useDefaultLogo() {
      if (this.uploadLogoId) {
        this.deleteUpload({
          id: this.uploadLogoId
        });
      }
      this.useIconFontLogoInKiosk = true;
    },
    showNetWork(netWork) {
      this.netWork.upLinkNetWork = netWork.upLinkNetWork;
      this.netWork.downLinkNetWork = netWork.downLinkNetWork;
    }
  },
  mounted() {
    let partyInfo = {};
    try {
      const localVal = handleLocalStorage('get', 'partyInfo');
      if (localVal) {
        partyInfo = JSON.parse(localVal);
      }
    } catch (e) {
      console.log(e);
    }
    if (partyInfo && partyInfo.code) {
      this.partyCode = partyInfo.code;
    }
    const URL = nodeurl.parse(location.href, true);
    if (URL.query.join_id || URL.query.id) {
      this.partyCode = URL.query.join_id || URL.query.id;
      this.showLeave = true;
    }
    if (this.$route.query.join_id || this.$route.query.id) {
      this.partyCode = this.$route.query.join_id || this.$route.query.id;
    }
    if (this.$route.path.indexOf('/control') >= 0 || this.State.checkEnv.owner) {
      this.isHost = true;
    }
    if (!this.isHost) {
      this.qCode = QRCode.toDataURL(this.urlAddress).then(url => {
        this.qrCodeUrl = url;
      });
    }
    this.logoSvg = `#${this.State.commonLogo}`;
  },
  beforeDestroy() {
    Bus.$off('setLoginScreenButton');
  }
};